module.exports = "/lucky-balls/img/regular_game/footer.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/footer.png
// module id = 1140
// module chunks = 0